import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChannelProfile, StreamProject} from "../shared/interfaces";
import {ChannelService} from "../shared/services/channel.service";
import {Subscription} from "rxjs";
//import {NbToastrService, NbGlobalPosition } from '@nebular/theme';


@Component({ 
  selector: 'app-channels-page', 
  templateUrl: './channels-page.component.html',
  styleUrls: ['./channels-page.component.scss'],
   
})
export class ChannelsPageComponent implements OnInit, OnDestroy, AfterViewInit{
 
   lSub$:Subscription;
   sSub$:Subscription;
   searchText: string = ''
   loading:boolean = true
   channels: ChannelProfile[];
   searchStreams: StreamProject[];
   searchVideos: StreamProject[];

  constructor(
	private channelService: ChannelService
  ){
	// this.channels = <ChannelProfile>[]
  }
   

  onSearch(text){
	 
	

	if(!text){
		this.loadChannels()
	}else{
		this.search(text)

	}

  }


     

  onCancelSearch(){
	this.searchText = ''
	this.loadChannels()
  }



   ngOnInit() { 
	this.loadChannels()
  }	


  loadChannels(){
	if(this.lSub$){
	  this.lSub$.unsubscribe()
	}

	this.channels = <ChannelProfile[]>[]
	this.searchStreams = <StreamProject[]>[]
	this.searchVideos = <StreamProject[]>[]
	this.loading = true

	this.lSub$ = this.channelService.viewFetchAll().subscribe((channels:ChannelProfile[])=>{
		 this.channels = channels 
		this.searchText = ''
	},(r)=>{   }, ()=>{this.loading = false; })

  }

   search(text){
	if(this.sSub$){
	  this.sSub$.unsubscribe()
	}

	this.channels = <ChannelProfile[]>[]
	this.searchStreams = <StreamProject[]>[]
	this.searchVideos = <StreamProject[]>[]
	this.loading = true

	this.sSub$ = this.channelService.viewChanelsSearch(text).subscribe((data)=>{
		 this.channels = <ChannelProfile[]>data.channels 

		if(data.streams?.length) {
			this.searchStreams = <StreamProject[]>data.streams

		}
		

		if(data.videos?.length) {
			this.searchVideos = <StreamProject[]>data.videos

		}
 
	},(r)=>{   }, ()=>{this.loading = false;  this.searchText = text})

   }

//

 
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   	if(this.lSub$){
	  this.lSub$.unsubscribe()
	}
	if(this.sSub$){
	  this.sSub$.unsubscribe()
	}
   }
  
}
